import { render, staticRenderFns } from "./extra-patientenverfuegung.vue?vue&type=template&id=48a13f40&lang=pug&"
import script from "./extra-patientenverfuegung.vue?vue&type=script&lang=js&"
export * from "./extra-patientenverfuegung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports